import { DateTime, Settings } from "luxon";

Settings.defaultLocale = "ja";